// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addCourseDetails,
//   editCourseDetails,
//   fetchCourseCategories,
// } from "../../../../../services/operations/courseDetailsAPI";
// import { HiOutlineCurrencyRupee } from "react-icons/hi";
// import { categories } from "../../../../../services/apis";
// import UploadFile from "./UploadFile";
// import RequirementField from "./RequirementField";
// import { setCourse, setStep } from "../../../../../slices/courseSlice";
// import { IoIosArrowForward } from "react-icons/io";
// import toast from "react-hot-toast";
// import { COURSE_STATUS } from "../../../../../utils/constants";

// function CourseInformationForm(props) {
//   const {
//     register,
//         handleSubmit,
//         setValue,
//         getValues,
//         formState:{errors},
//   } = useForm();

//   const dispatch = useDispatch();

//   const { token } = useSelector((state) => state.auth);
//   const { course, editCourse } = useSelector((state) => state.course);
//   const [loading, setLoading] = useState(false);
//   const [courseCategories, setCourseCategories] = useState([]);

//   useEffect(() => {
//     const getCategories = async () => {
//       setLoading(true);
//       const categories = await fetchCourseCategories();
//       console.log("Data", categories);
//       if (categories.length > 0) {
//         setCourseCategories(categories);
//       }
//       if (editCourse) {
//         setValue("courseTitle", course.courseName);
//         setValue("courseShortDesc", course.courseDescription);
//         setValue("coursePrice", course.price);
//         setValue("courseTags", course.tag);
//         setValue("courseBenefits", course.whatYouWillLearn);
//         setValue("courseCategory", course.category);
//         setValue("courseRequirements", course.instructions);
//         setValue("courseImage", course.thumbnail);
//       }

//       setLoading(false);
//     };

//     getCategories();
//   }, []);

// //   // const isFormUpadted = () => {
// //   //   const currentValue = getValues();
// //   //   if (
// //   //     currentValue.courseTitle !== course.courseName ||
// //   //     currentValue.courseShortDesc !== course.courseDescription ||
// //   //     currentValue.coursePrice !== course.price ||
// //   //     // currentValue.courseTags.toString() !== course.courseName.toString() ||
// //   //     currentValue.courseBenefits !== course.whatYouWillLearn ||
// //   //     currentValue.courseCategory !== course.category ||
// //   //     currentValue.courseRequirements !== course.instructions
// //   //     // ||
// //   //     // currentValue.courseImage !== course.thumbnail
// //   //   )
// //   //     return true;
// //   //   else {
// //   //     return false;
// //   //   }
// //   // };

// //   // // handles next button click
// //   // const onSubmit = async (data) => {
// //   //   if (editCourse) {
// //   //     if (isFormUpadted) {
// //   //       const currentValue = getValues();
// //   //       const formData = new FormData();

// //   //       formData.append("courseId", course._id);
// //   //       if (currentValue.courseTitle !== course.courseName) {
// //   //         formData.append("courseName", data.courseTitle);
// //   //       }
// //   //       if (currentValue.courseShortDesc !== course.courseDescription) {
// //   //         formData.append("courseDescription", data.courseShortDesc);
// //   //       }
// //   //       if (currentValue.coursePrice !== course.price) {
// //   //         formData.append("price", data.coursePrice);
// //   //       }
// //   //       // if (currentValue.courseTags !== course.tag) {
// //   //       //   formData.append("courseTags", data.tag);
// //   //       // }
// //   //       if (currentValue.courseBenefits !== course.whatYouWillLearn) {
// //   //         formData.append("courseBenefits", data.whatYouWillLearn);
// //   //       }
// //   //       if (currentValue.courseCategory._id !== course.category._id) {
// //   //         formData.append("courseCategory", data.category);
// //   //       }
// //   //       if (
// //   //         currentValue.courseRequirements.toString() !==
// //   //         course.instructions.toString()
// //   //       ) {
// //   //         formData.append(
// //   //           "courseRequirements",
// //   //           JSON.stringify(data.instructions)
// //   //         );
// //   //       }
// //   //       // if (currentValue.courseImage !== course.thumbnail) {
// //   //       //   formData.append("courseImage", data.thumbnail);
// //   //       // }

// //   //       setLoading(true);
// //   //       const result = await editCourseDetails(formData, token);
// //   //       setLoading(false);
// //   //       if (result) {
// //   //         setStep(2);
// //   //         dispatch(setCourse(result));
// //   //       } else {
// //   //         toast.error("Course was unable to be updated");
// //   //       }
// //   //       return;
// //   //     }
// //   //   }

// //   //   // create a new course
// //   //   console.log("On Submit")
// //   //   const formData = new FormData();
// //   //   formData.append("courseName", data.courseTitile);
// //   //   formData.append("courseDescription", data.courseShortDesc);
// //   //   formData.append("price", data.coursePrice);
// //   //   // formData.append("courseTags", data.tag);
// //   //   formData.append("whatYouWillLearn", data.courseBenefits);
// //   //   formData.append("category", data.courseCategory);
// //   //   formData.append("instructions", JSON.stringify(data.courseRequirements));
// //   //   formData.append("status",COURSE_STATUS.DRAFT);

// //   //   setLoading(true);
// //   //   const result = await addCourseDetails(formData,token);
// //   //   if(result)
// //   //   {
// //   //     setStep(2);
// //   //     dispatch(setCourse(result));
// //   //   }
// //   //   setLoading(false);
// //   //   console.log("FormData after call:",formData);
// //   //   console.log("Result: ",result);

// //   // };
//   const isFormUpdated = () => {
//     const currentValues = getValues();
//     if (
//       currentValues.courseTitle !== course.courseName ||
//       currentValues.courseShortDesc !== course.courseDescription ||
//       currentValues.coursePrice !== course.price ||
//       currentValues.courseTitle !== course.courseName ||
//       //currentValues.courseTags.toString() !== course.tag.toString() ||
//       currentValues.courseBenefits !== course.whatYouWillLearn ||
//       currentValues.courseCategory._id !== course.category._id ||
//       //currentValues.courseImage !== course.thumbnail ||
//       currentValues.courseRequirements.toString() !==
//         course.instructions.toString()
//     )
//       return true;
//     else return false;
//   };

// //   //handles next button click
//   const onSubmit = async (data) => {
//     console.log("Printing before submit")
//     if (editCourse) {
//       if (isFormUpdated()) {
//         const currentValues = getValues();
//         const formData = new FormData();

//         formData.append("courseId", course._id);
//         if (currentValues.courseTitle !== course.courseName) {
//           formData.append("courseName", data.courseTitle);
//         }

//         if (currentValues.courseShortDesc !== course.courseDescription) {
//           formData.append("courseDescription", data.courseShortDesc);
//         }

//         if (currentValues.coursePrice !== course.price) {
//           formData.append("price", data.coursePrice);
//         }

//         if (currentValues.courseBenefits !== course.whatYouWillLearn) {
//           formData.append("whatYouWillLearn", data.courseBenefits);
//         }

//         if (currentValues.courseCategory._id !== course.category._id) {
//           formData.append("category", data.courseCategory);
//         }

//         if (
//           currentValues.courseRequirements.toString() !==
//           course.instructions.toString()
//         ) {
//           formData.append(
//             "instructions",
//             JSON.stringify(data.courseRequirements)
//           );
//         }

//         setLoading(true);
//         const result = await editCourseDetails(formData, token);
//         setLoading(false);
//         if (result) {
//           setStep(2);
//           dispatch(setCourse(result));
//         }
//       } else {
//         toast.error("NO Changes made so far");
//       }
//       console.log("PRINTING FORMDATA", formData);
//       console.log("PRINTING result", result);

//       return;
//     }

//     //create a new course
//     const formData = new FormData();
//     formData.append("courseName", data.courseTitle);
//     formData.append("courseDescription", data.courseShortDesc);
//     formData.append("price", data.coursePrice);
//     formData.append("whatYouWillLearn", data.courseBenefits);
//     formData.append("category", data.courseCategory);
//     formData.append("instructions", JSON.stringify(data.courseRequirements));
//     formData.append("status", COURSE_STATUS.DRAFT);

//     setLoading(true);
//     console.log("BEFORE add course API call");
//     console.log("PRINTING FORMDATA", formData);
//     const result = await addCourseDetails(formData, token);
//     if (result) {
//       setStep(2);
//       dispatch(setCourse(result));
//     }
//     setLoading(false);
//     console.log("PRINTING FORMDATA", formData);
//     console.log("PRINTING result", result);
//   };

//   return (
//     <div className="text-richblack-25">
//       <form
//         onSubmit={handleSubmit(onSubmit)}
//         className="rounded-md border-richblack-700 bg-richblack-800 p-6 spance-y-8">
//         <div className="flex flex-col gap-y-2">
//           <label htmlFor="courseTitle" className="rich-richblack-400">
//             Course Title <sup className="text-pink-200">*</sup>
//           </label>
//           <input
//             type="text"
//             id="courseTitle"
//             placeholder="Enter course title"
//             {...register("courseTitle", { required: true })}
//             className="w-full bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"
//           />
//           {errors.courseTitle && <span>Course title is required</span>}
//         </div>

//         {/* Course short description */}
//         <div className="flex flex-col gap-y-2 mt-5">
//           <label htmlFor="courseShortDesc" className="rich-richblack-400">
//             Course short description <sup className="text-pink-200">*</sup>
//           </label>
//           <textarea
//             name="courseShortDesc"
//             id="courseShortDesc"
//             cols="30"
//             rows="10"
//             placeholder="Enter description"
//             {...register("courseShortDesc", { required: true })}
//             className="resize-none w-full bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"></textarea>

//           {errors.courseShortDesc && (
//             <span>Course short description is required</span>
//           )}
//         </div>

//         {/* Price */}
//         <div className="relative flex flex-col gap-y-2 mt-5">
//           <label htmlFor="price" className="rich-richblack-400">
//             Price <sup className="text-pink-200">*</sup>
//           </label>
//           <div className="relative">
//             <input
//               type="number"
//               name="price"
//               id="price"
//               placeholder="Enter price"
//               {...register("price", {
//                 required: true,
//                 valueAsNumber: true,
//                 // pattern:
//               })}
//               className="w-full bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"
//             />
//             <HiOutlineCurrencyRupee className="absolute top-1 left-12 text-richblack-700" />
//           </div>
//           {errors.price && <span>Course price is required</span>}
//         </div>

//         {/* Course category */}
//         <div className="flex flex-col gap-y-2 mt-5">
//           <label htmlFor="courseCategory" className="rich-richblack-400">
//             Course Category <sup className="text-pink-200">*</sup>
//           </label>
//           <select
//             name="courseCategory"
//             id="courseCategory"
//             defaultValue={""}
//             className="w-full bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"
//             {...register("courseCategory", { required: true })}>
//             <option
//               value=""
//               className="text-richblack-100 text-lg bg-richblack-700"
//               disabled>
//               Choose a Category
//             </option>
//             {!loading &&
//               courseCategories.map((category, index) => (
//                 <option
//                   key={index}
//                   value={category?.id}
//                   className="text-richblack-100 text-lg bg-richblack-700">
//                   {category?.name}
//                 </option>
//               ))}
//           </select>
//           {errors.courseCategory && <span>Course category is required</span>}
//         </div>

//         {/* create custom component for handling tag */}
//         {/* <TagInput/> */}

//         {/* upload thumbnail */}
//         <div className="flex flex-col gap-y-2 mt-5">
//           <label htmlFor="uploadFile" className="rich-richblack-400">
//             Course Thumbnail <sup className="text-pink-200">*</sup>
//           </label>
//           <UploadFile
//             name="uploadFile"
//             register={register}
//             errors={errors}
//             setValue={setValue}
//             getValues={getValues}
//           />
//         </div>

//         {/* Benefits of the course */}
//         <div className="flex flex-col gap-y-2 mt-5">
//           <label htmlFor="courseBenefits" className="rich-richblack-400">
//             Benefits of the course <sup className="text-pink-200">*</sup>
//           </label>
//           <textarea
//             name="courseBenefits"
//             id="courseBenefits"
//             cols="30"
//             rows="5"
//             placeholder="Enter Benefits of the course"
//             {...register("courseBenefits", { required: true })}
//             className="resize-none w-full bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"></textarea>

//           {errors.courseBenefits && (
//             <span>Course short description is required</span>
//           )}
//         </div>

//         {/* requirement field */}
//         <RequirementField
//           name="courseRequirements"
//           label="Requirements/Instructions"
//           register={register}
//           errors={errors}
//           setValue={setValue}
//           getValues={getValues}
//         />

//         <div className="w-full flex">
//           {/* {
//           editCourse && (
//             <button type="button" onClick={() => dispatch(setStep(2))}>
//               Continue Without Saving
//             </button>
//           )} */}

//           <button
//             className="bg-yellow-25 text-richblack-900 py-2 px-4 rounded-md">
//             {!editCourse ? (
//               <span className="flex justify-center items-center gap-2">
//                 Next <IoIosArrowForward />
//               </span>
//             ) : (
//               "Save Changes"
//             )}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default CourseInformationForm;


// code reference
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-hot-toast"
import { HiOutlineCurrencyRupee } from "react-icons/hi"
import { MdNavigateNext } from "react-icons/md"
import { useDispatch, useSelector } from "react-redux"

import {
  addCourseDetails,
  editCourseDetails,
  fetchCourseCategories,
} from "../../../../../services/operations/courseDetailsAPI"
import { setCourse, setStep } from "../../../../../slices/courseSlice"
import { COURSE_STATUS } from "../../../../../utils/constants"
import IconBtn from "./IconButton"
import Upload from "./Upload"
import ChipInput from "./ChipInput"
import RequirementsField from "./RequirementField"

export default function CourseInformationForm() {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm()

  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth)
  const { course, editCourse } = useSelector((state) => state.course)
  const [loading, setLoading] = useState(false)
  const [courseCategories, setCourseCategories] = useState([])

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true)
      const categories = await fetchCourseCategories()
      if (categories.length > 0) {
        // console.log("categories", categories)
        setCourseCategories(categories)
      }
      setLoading(false)
    }
    // if form is in edit mode
    if (editCourse) {
      // console.log("data populated", editCourse)
      setValue("courseTitle", course.courseName)
      setValue("courseShortDesc", course.courseDescription)
      setValue("coursePrice", course.price)
      setValue("courseTags", course.tag)
      setValue("courseBenefits", course.whatYouWillLearn)
      setValue("courseCategory", course.category)
      setValue("courseRequirements", course.instructions)
      setValue("courseImage", course.thumbnail)
    }
    getCategories()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isFormUpdated = () => {
    const currentValues = getValues()
    // console.log("changes after editing form values:", currentValues)
    if (
      currentValues.courseTitle !== course.courseName ||
      currentValues.courseShortDesc !== course.courseDescription ||
      currentValues.coursePrice !== course.price ||
      currentValues.courseTags.toString() !== course.tag.toString() ||
      currentValues.courseBenefits !== course.whatYouWillLearn ||
      currentValues.courseCategory._id !== course.category._id ||
      currentValues.courseRequirements.toString() !==
        course.instructions.toString() ||
      currentValues.courseImage !== course.thumbnail
    ) {
      return true
    }
    return false
  }

  //   handle next button click
  const onSubmit = async (data) => {
    // console.log(data)

    if (editCourse) {
      // const currentValues = getValues()
      // console.log("changes after editing form values:", currentValues)
      // console.log("now course:", course)
      // console.log("Has Form Changed:", isFormUpdated())
      if (isFormUpdated()) {
        const currentValues = getValues()
        const formData = new FormData()
        // console.log(data)
        formData.append("courseId", course._id)
        if (currentValues.courseTitle !== course.courseName) {
          formData.append("courseName", data.courseTitle)
        }
        if (currentValues.courseShortDesc !== course.courseDescription) {
          formData.append("courseDescription", data.courseShortDesc)
        }
        if (currentValues.coursePrice !== course.price) {
          formData.append("price", data.coursePrice)
        }
        if (currentValues.courseTags.toString() !== course.tag.toString()) {
          formData.append("tag", JSON.stringify(data.courseTags))
        }
        if (currentValues.courseBenefits !== course.whatYouWillLearn) {
          formData.append("whatYouWillLearn", data.courseBenefits)
        }
        if (currentValues.courseCategory._id !== course.category._id) {
          formData.append("category", data.courseCategory)
        }
        if (
          currentValues.courseRequirements.toString() !==
          course.instructions.toString()
        ) {
          formData.append(
            "instructions",
            JSON.stringify(data.courseRequirements)
          )
        }
        if (currentValues.courseImage !== course.thumbnail) {
          formData.append("thumbnailImage", data.courseImage)
        }
        // console.log("Edit Form data: ", formData)
        setLoading(true)
        const result = await editCourseDetails(formData, token)
        setLoading(false)
        if (result) {
          dispatch(setStep(2))
          dispatch(setCourse(result))
        }
      } else {
        toast.error("No changes made to the form")
      }
      return
    }

    const formData = new FormData()
    formData.append("courseName", data.courseTitle)
    formData.append("courseDescription", data.courseShortDesc)
    formData.append("price", data.coursePrice)
    formData.append("tag", JSON.stringify(data.courseTags))
    formData.append("whatYouWillLearn", data.courseBenefits)
    formData.append("category", data.courseCategory)
    formData.append("status", COURSE_STATUS.DRAFT)
    formData.append("instructions", JSON.stringify(data.courseRequirements))
    formData.append("thumbnailImage", data.courseImage)
    setLoading(true)
    const result = await addCourseDetails(formData, token)
    if (result) {
      dispatch(setStep(2))
      dispatch(setCourse(result))
    }
    setLoading(false)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-8 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-6"
    >
      {/* Course Title */}
      <div className="flex flex-col space-y-2">
        <label className="text-richblack-50" htmlFor="courseTitle">
          Course Title <sup className="text-pink-200">*</sup>
        </label>
        <input
          id="courseTitle"
          placeholder="Enter Course Title"
          {...register("courseTitle", { required: true })}
        //   className="form-style w-full"
            className="w-full bg-richblack-700 text-richblack-50 py-2 px-4 rounded-md border-b border-richblack-500"

        />
        {errors.courseTitle && (
          <span className="ml-2 text-xs tracking-wide text-pink-200">
            Course title is required
          </span>
        )}
      </div>
      {/* Course Short Description */}
      <div className="flex flex-col space-y-2">
        <label className="text-richblack-50" htmlFor="courseShortDesc">
          Course Short Description <sup className="text-pink-200">*</sup>
        </label>
        <textarea
          id="courseShortDesc"
          placeholder="Enter Description"
          {...register("courseShortDesc", { required: true })}
          className="resize-none w-full bg-richblack-700 text-richblack-50 py-2 h-32 px-4 rounded-md border-b border-richblack-500"
        />
        {errors.courseShortDesc && (
          <span className="ml-2 text-xs tracking-wide text-pink-200">
            Course Description is required
          </span>
        )}
      </div>
      {/* Course Price */}
      <div className="flex flex-col space-y-2">
        <label className="text-richblack-50" htmlFor="coursePrice">
          Course Price <sup className="text-pink-200">*</sup>
        </label>
        <div className="relative">
          <input
            id="coursePrice"
            placeholder="Enter Course Price"
            {...register("coursePrice", {
              required: true,
              valueAsNumber: true,
              pattern: {
                value: /^(0|[1-9]\d*)(\.\d+)?$/,
              },
            })}
            className="form-style !pl-12 w-full bg-richblack-700 text-richblack-50 py-2 px-4 rounded-md border-b border-richblack-500"

          />
          <HiOutlineCurrencyRupee className="absolute left-3 top-1/2 inline-block -translate-y-1/2 text-2xl text-richblack-400" />
        </div>
        {errors.coursePrice && (
          <span className="ml-2 text-xs tracking-wide text-pink-200">
            Course Price is required
          </span>
        )}
      </div>
      {/* Course Category */}
      <div className="flex flex-col space-y-2">
        <label className="text-richblack-50" htmlFor="courseCategory">
          Course Category <sup className="text-pink-200">*</sup>
        </label>
        <select
          {...register("courseCategory", { required: true })}
          defaultValue=""
          id="courseCategory"
          className="w-full bg-richblack-700 text-richblack-50 py-2 px-4 rounded-md border-b border-richblack-500"
        >
          <option value="" disabled>
            Choose a Category
          </option>
          {!loading &&
            courseCategories?.map((category, index) => (
              <option className="text-richblack-50" key={index} value={category?._id}>
                {category?.name}
              </option>
            ))}
        </select>
        {errors.courseCategory && (
          <span className="ml-2 text-xs tracking-wide text-pink-200">
            Course Category is required
          </span>
        )}
      </div>
      {/* Course Tags */}
      <ChipInput
        label="Tags"
        name="courseTags"
        placeholder="Enter Tags and press Enter"
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
      />
      {/* Course Thumbnail Image */}
      <Upload
        name="courseImage"
        label="Course Thumbnail"
        register={register}
        setValue={setValue}
        errors={errors}
        editData={editCourse ? course?.thumbnail : null}
      />
      {/* Benefits of the course */}
      <div className="flex flex-col space-y-2">
        <label className="text-richblack-50" htmlFor="courseBenefits">
          Benefits of the course <sup className="text-pink-200">*</sup>
        </label>
        <textarea
          id="courseBenefits"
          placeholder="Enter benefits of the course"
          {...register("courseBenefits", { required: true })}
        //   className="form-style resize-x-none min-h-[130px] w-full"
        className="resize-none text-richblack-50 w-full h-32 bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"
        />
        {errors.courseBenefits && (
          <span className="ml-2 text-xs tracking-wide text-pink-200">
            Benefits of the course is required
          </span>
        )}
      </div>
      {/* Requirements/Instructions */}
      <RequirementsField
        name="courseRequirements"
        label="Requirements/Instructions"
        register={register}
        setValue={setValue}
        errors={errors}
        getValues={getValues}
      />
      {/* Next Button */}
      <div className="flex justify-end gap-x-2">
        {editCourse && (
          <button
            onClick={() => dispatch(setStep(2))}
            disabled={loading}
            className={`flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900`}
          >
            Continue Without Saving
          </button>
        )}
        <IconBtn
          disabled={loading}
          text={!editCourse ? "Next" : "Save Changes"}
          type={"submit"}
        >
          <MdNavigateNext />
        </IconBtn>
      </div>
    </form>
  )
}
